/* tslint:disable */
/* eslint-disable */
/**
 * MinSide.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum Language {
    Norwegian = 'Norwegian',
    English = 'English',
    Swedish = 'Swedish'
}


export function instanceOfLanguage(value: any): boolean {
    for (const key in Language) {
        if (Object.prototype.hasOwnProperty.call(Language, key)) {
            if (Language[key as keyof typeof Language] === value) {
                return true;
            }
        }
    }
    return false;
}

export function LanguageFromJSON(json: any): Language {
    return LanguageFromJSONTyped(json, false);
}

export function LanguageFromJSONTyped(json: any, ignoreDiscriminator: boolean): Language {
    return json as Language;
}

export function LanguageToJSON(value?: Language | null): any {
    return value as any;
}

export function LanguageToJSONTyped(value: any, ignoreDiscriminator: boolean): Language {
    return value as Language;
}

